import { AccessDeps } from 'features/Access/infra/react/AccessState'
import { HTTPError } from 'ky'
import { DateLib } from 'libs/Date'
import { restClient } from 'presentation/libs/client'

export const register: AccessDeps['register'] = async payload =>
  await restClient.post('register', {
    json: {
      email: payload.email,
      password: payload.password,
      firstname: payload.name.first,
      lastname: payload.name.last,
      timezone: DateLib.getTimezone(),
      confirmationUrl: window.location.origin,
      planId: payload.planId,
      ...payload.paymentMethodId ? { card: payload.paymentMethodId } : {},
    },
  })
    .json()
    .then(() => ({
      status: 'success' as const,
    }))
    .catch(async error => {
      if (error instanceof HTTPError) {
        try {
          const errorData = await error.response.json()

          if (errorData?.error?.type === 'email_already_exists')
            return { status: 'email-taken-error' as const }


          if (error.response.status === 403 && errorData?.error?.type === 'authorization_error') {
            return {
              status: 'spam-error' as const,
              message: errorData.error.message || 'Registration flagged as spam. Please contact support.',
            }
          }
        } catch (e) {
          // Failed to parse JSON
        }
      }

      throw error
    })
